import { tokens, useFluentTokens } from '../../../../../theme/fluent';
import { makeStyles } from '@fluentui/react-components';

export const dashboardBadgeStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: '33%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: tokens.borderRadiusXXXLarge,
    fontFamily: tokens.fontFamilyBase,
    textDecoration: 'none',
  },
  padding: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingVerticalS}`,
    maxWidth: 'none',
  },
  counter: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase400,
    marginBottom: tokens.spacingVerticalXXS,
  },
  label: {
    paddingLeft: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase100,
    lineHeight: 1,
    fontWeight: tokens.fontWeightRegular,
    wordBreak: 'break-word',
    hyphens: 'auto',
  },
  ellipsis: {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const useDasboardBadgeStyles = () => {
  const classes = dashboardBadgeStyles();
  const { modeTokens } = useFluentTokens();
  const badgeVariants = {
    informative: {
      backgroundColor: modeTokens.colorNeutralBackground5,
      color: modeTokens.colorNeutralForeground1,
      border: `1px solid ${modeTokens.colorNeutralBackground3Pressed}`,
    },
    warning: {
      backgroundColor: modeTokens.colorOrangeBackground,
      color: modeTokens.colorOrangeForeground,
      border: `1px solid ${modeTokens.colorOrangeBorder}`,
    },
    danger: {
      backgroundColor: modeTokens.colorRedBackground,
      color: modeTokens.colorRedForeground,
      border: `1px solid ${modeTokens.colorRedBorder}`,
    },
    success: {
      backgroundColor: modeTokens.colorGreenBackground,
      color: modeTokens.colorGreenForeground,
      border: `1px solid ${modeTokens.colorGreenBorder}`,
    },
  };
  return { classes, badgeVariants };
};
